import Container from "../common/Container";
import SectionLabel from "../common/SectionLabel";
import { experienceItems } from "../../data/portfolioData";
import { useRevealOnScroll } from "../../hooks/useRevealOnScroll";

const Experience = () => {
  useRevealOnScroll();

  return (
    <section id="experience">
      <Container>
        <SectionLabel number="03" label="Experience" />

        <div className="exp-list">
          {experienceItems.map((item) => (
            <div className="exp-item reveal-on-scroll" key={`${item.company}-${item.period}`}>
              <div className="exp-left">
                <div className="exp-period">{item.period}</div>
                <div className="exp-company">{item.company}</div>
              </div>

              <div className="exp-right">
                <div className="exp-role">{item.role}</div>
                <p className="exp-desc">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Experience;
